import { inject, Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { DialogService, KdsToastService, SidePanelService } from '@kaseya-design-components';
import { AuthorizationService } from '@core/authorization/services/authorization.service';
import { ApplicationPath } from '@core/navigation/models/application-path.enum';
import { UserInfoFacade } from '@core/user-info/facades/user-info.facade';
import { DeepLinkFacade } from '@core/deep-link/store/facade/deep-link.facade';

@Injectable({ providedIn: 'root' })
export class SessionExpirationService {
  private readonly authorizationService = inject(AuthorizationService);
  private readonly sidePanelService = inject(SidePanelService);
  private readonly kdsToastService = inject(KdsToastService);
  private readonly userInfoFacade = inject(UserInfoFacade);
  private readonly router = inject(Router);
  private readonly dialogService = inject(DialogService);
  private readonly location = inject(Location);
  private readonly deepLinkFacade = inject(DeepLinkFacade);

  expireSession(): Promise<boolean> {
    this.deepLinkFacade.setDeepLink(this.location.path());
    const { lastOrganizationName, lastOrganizationTrackingId } = this.userInfoFacade;

    this.authorizationService.logOut();
    this.dialogService.dismissAll();
    this.sidePanelService.closePanelIfExists();
    this.kdsToastService.closeAllToasts();

    return this.router.navigate([ApplicationPath.Login], {
      queryParams: {
        companyName: lastOrganizationName(),
        uuid: lastOrganizationTrackingId(),
      },
    });
  }
}
